<template>
    <div id="add-block-container" v-if="!isGuest" :class="{ disabled: !canUseColorGradingTools || blockLoading }"  name="addBlockBtn">
        <tippy
            v-if="startTipsStep == 4"
            placement="top"
            boundary="window"
            theme="--start"
            showOnInit="true"
            hideOnClick="false"
            interactive
            :onHide="() => { if (startTipsStep == 4) return false }"
            to="addBlockBtn"
        >
            <span class="step">{{ startTipsStep }} of {{ $startTips.length }}</span>
            <span class="title">{{ $startTips[startTipsStep - 1].title }}</span>
            <span class="description">{{ $startTips[startTipsStep - 1].description }}</span>
        </tippy>
        <tippy v-else-if="!image" showOnInit="false" theme="" to="addBlockBtn">
            Please load an image
            <br />
            to access editing tools
        </tippy>
        <tippy v-else showOnInit="false" theme="" to="addBlockBtn">Add a new tool</tippy>
        <span id="btn-add-block">
            <i class="material-icons">add_circle_outline</i>
            Add Tool
        </span>
    </div>
</template>

<script>
import CanMixin from "@/mixins/CanMixin";
import { mapGetters, mapState } from "vuex";

export default {
    name: "AddBlockButton",
    mixins: [CanMixin],

    computed: {
        ...mapState("UI", ["startTipsStep"]),
        ...mapState("Projects", ["image"]),
        ...mapState("App", ["blockLoading"]),
        ...mapGetters("User", ["isGuest"]),
    }
}
</script>

<style scoped>
</style>